module.exports = __webpack_public_path__ + "img/12b)(Campeon) Einrichtung der gesamten Bereiche.jpg";